import {
  GESTION_OPERATIVA_RETRY_OFFER_BEGIN,
  GESTION_OPERATIVA_RETRY_OFFER_SUCCESS,
  GESTION_OPERATIVA_RETRY_OFFER_FAILURE,
  GESTION_OPERATIVA_RETRY_OFFER_DISMISS_ERROR
} from '../constants'

export const reducer = (state, action) => {
  switch (action.type) {
    case GESTION_OPERATIVA_RETRY_OFFER_SUCCESS: {
      // Prepare received structure data
      const raw = action.data || {}
      const layers = [raw.data?.data, raw.data, raw].filter(Boolean)

      const findProp = selector => layers.reduce((acc, layer) => acc || selector(layer), null)

      const externalId =
        findProp(dataLayer => dataLayer.external_id || dataLayer.Sale_DMS_Integration?.external_id) ||
        findProp(dataLayer => dataLayer.DMS_offer_number)

      let errors = findProp(_dataLayer => _dataLayer.integration_errors || _dataLayer.Sale_DMS_Integration?.integration_errors) || ''

      const isSuccess = raw.success === true || raw.data?.success === true || !!externalId

      if (isSuccess) errors = ''
      
      else if (Array.isArray(errors)) errors = errors.join(';')

      const responseData = raw.data || {}

      return {
        ...state,
        retryOfferDMSPending: false,
        retryOfferDMSError: null,
        retryOfferDMSSuccess: isSuccess,
        sale: {
          ...state.sale,
          ...responseData,
          DMS_offer_number: externalId || responseData.DMS_offer_number || state.sale.DMS_offer_number,
          DMS_error_messages: errors
        }
      }
    }

    case GESTION_OPERATIVA_RETRY_OFFER_FAILURE:
      return {
        ...state,
        retryOfferDMSError: action.data?.error?.response?.data?.message || 'Error en la integración',
        retryOfferDMSPending: false,
        retryOfferDMSSuccess: false
      }

    case GESTION_OPERATIVA_RETRY_OFFER_DISMISS_ERROR:
      return {
        ...state,
        retryOfferDMSError: null,
        retryOfferDMSPending: false,
        retryOfferDMSSuccess: false
      }
    
    case GESTION_OPERATIVA_RETRY_OFFER_BEGIN:
      return {
        ...state,
        retryOfferDMSPending: true,
        retryOfferDMSError: null,
        retryOfferDMSSuccess: false
      }

    default:
      return state
  }
}